// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__R7s_e","col":"styles_col__3WkAS"};